import cloneDeep from 'lodash/cloneDeep';
import * as mathUtils from "./mathUtils";

const defaultViewState = {
  isOpened: false,
  sliderActive: false,
  components: []
}

const buildViewState = (components, currViewState) => {
  currViewState = currViewState || [];
  components.forEach((component, index) => {
    if(!currViewState[index]){
      currViewState[index] = cloneDeep(defaultViewState);
    }
    if(component.components && component.components.length){
      buildViewState(component.components, currViewState[index].components)
    }
  });
  return currViewState;
};

const componentIdToRestriction = {
  "reviews": "hideReviews",
  "reviews.response": "hideReviewResponses",
  "reviews.sentiment": "hideSentiment",
  "listings": "hideListings",
  "rankings": "hideRankings",
  "rankings.insights": "hideGoogleInsights",
  "competitors": "hideCompetitors"
};

const disableAccountRestricted = (accountRestrictions, selectedAccountIds, component) => {
  component.isEnabled = uiUtils.isEnabled(accountRestrictions, selectedAccountIds, component.id);
  if(component.components && component.components.length){
    component.components.forEach(childComponent => disableAccountRestricted(accountRestrictions, selectedAccountIds, childComponent));
  }
};


const uiUtils = {
  buildViewState,
  newViewStateComponent: () => cloneDeep(defaultViewState),
  sumOnWeight: (properties) => {
    return properties.reduce((t, property) => {
      return t + property.weight
    }, 0);
  },
  inputValue: (newValue, total, currentValue) => {
    const value = newValue || "0";
    const valueAsInt = parseInt(value, 10);
    if ((total - currentValue) + valueAsInt <= 100) {
      return valueAsInt;
    } else {
      return 100 - (total - currentValue);
    }
  },
  idTypeCategory: id => {
    const idReflection = id.split('.');
    return {
      type: idReflection[idReflection.length -1],
      category: idReflection[0]
    }
  },
  distributeWeightedOptions: (currentOption, options, weight, filteredOptionsFunction) => {
    // when weight comes from rc-slider its just a weight, from text fields e.target.weight

    let suggestedNewWeight = Math.round(parseFloat(weight, 10));
    if(suggestedNewWeight > 100) suggestedNewWeight = 100;
    let moveDelta = currentOption.weight - suggestedNewWeight;
    let enabledFields = options.filter(filteredOptionsFunction);
    if(!enabledFields.length){
      return options;
    }
    let moveStep = moveDelta / enabledFields.length;
    //can not step below 0 so don't even try
    if(moveStep < 0){
      enabledFields = enabledFields.filter(f => f.weight);
      moveStep = mathUtils.roundDecimal(moveDelta / enabledFields.length);
    }

    enabledFields.forEach(field => {
      // if doing <= 0 keeps from going negative but will stop from full 100, just need to re-init mouse event
      if(moveStep < 0 && field.weight + moveStep < 0){
        moveDelta += field.weight;
        field.weight = 0;
      }
    });

    // one more time
    if(moveStep < 0) {
      //filter out 0's and recalculate moveStep
      enabledFields = enabledFields.filter(f => f.weight);
      moveStep = mathUtils.roundDecimal(moveDelta / enabledFields.length);
    }

    //TODO - check if we should assign to moveDelta or suggestedNewWeight
    if(!enabledFields.length){
      return options;
    }

    // update fields
    currentOption.weight = suggestedNewWeight;
    enabledFields.forEach(field => {
      field.weight = mathUtils.roundDecimal(field.weight + moveStep);
    });

    // a little clean up because we are getting off factions with .toFixed() / 1
    let overUnder = mathUtils.roundDecimal(100 - (suggestedNewWeight + uiUtils.sumOnWeight(options.filter(f => f !== currentOption))));
    if(overUnder !== 0){
      const last = enabledFields[enabledFields.length - 1];
      last.weight = mathUtils.roundDecimal(last.weight + overUnder);
    }
    return options;
  },
  disableAccountRestricted,
  isEnabled: (accountRestrictions, selectedAccountIds, componentId) => {
    //looks expensive when binding to all
    let isEnabled = false;
    const enableCheck = acctId => {
      isEnabled = isEnabled || accountRestrictions[acctId] && !(accountRestrictions[acctId][componentIdToRestriction[componentId]]);
    };
    if(componentIdToRestriction[componentId] && selectedAccountIds.length){
      selectedAccountIds.forEach(enableCheck);
    }else if(componentIdToRestriction[componentId]){
      Object.keys(accountRestrictions).forEach(enableCheck);
    }else{
      isEnabled = true;
    }
    return isEnabled;
  },
  idsToHex: {
    'reviews': '#2FB1BB',
    'social': '#0093BE',
    'listings': '#455F7E',
    'rankings': '#F56C00',
    'competitors': '#FBA900'
  },
};

export default uiUtils;

